import React, {Component} from 'react';

import { Box, type Theme } from '@mui/material';

import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar'; 
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Help from '@mui/icons-material/Help';
import {CenterGrid} from '../../components/layout';

const s:any ={
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
    py: 4,
  },
  paper: {
    maxWidth: 700,
    width: '100%',
    mx: 'auto',
  },
  loginform: {
    p: 4,
    textAlign: 'center',
  },
  titlebar: {
    color: 'white',
    textAlign: 'center',
    flex: 1,
    fontWeight: 500,
  },
  versionBox: {
    mb: 3,
    mt: 2,
  },
  versionText: {
    fontSize: '1.75rem',
    fontWeight: 600,
    color: 'primary.main',
    mb: 1,
  },
  systemName: {
    fontSize: '1.25rem',
    fontWeight: 500,
    color: 'text.primary',
    mb: 2,
  },
  featuresBox: {
    mb: 3,
    mt: 2,
  },
  featuresText: {
    fontSize: '1rem',
    color: 'text.secondary',
    lineHeight: 1.8,
  },
  copyrightBox: {
    mb: 2,
    mt: 3,
  },
  copyrightText: {
    fontSize: '0.9rem',
    color: 'text.secondary',
    fontStyle: 'italic',
  },
  emailBox: {
    mb: 3,
    mt: 2,
  },
  emailText: {
    fontSize: '1rem',
    color: 'primary.main',
    fontWeight: 500,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 2,
    mt: 3,
    mb: 2,
    flexWrap: 'wrap',
  },
  button: {
    minWidth: 160,
    px: 3,
    py: 1.5,
  },
  leftIcon: {
    mr: 1,
  },
  logo: (theme:Theme)=> ({
    cursor: 'pointer',
    fontSize: 22,
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightLight,
    backgroundImage: 'url(lib/img/logo.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: '0 50%',
    backgroundColor: 'transparent',
    paddingLeft: 5,
    paddingRight: 5,
    height: 20,
    width:25,
    [theme.breakpoints.down('sm')]:{
      display:'none',
    },
  })
  
};

class About extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);

    this.state = {
      loading: false,
      count: 0,
      open: false,
      sbopen: false,
      sbmesg: '',
      username: '',
      password:'',
      showPassword: false,
      context: props.context,
      serviceid: 1,
      remember: false
    };
  }

  onHelp = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'help';
    this.props.handleSetContent(null,page).then( () => {
      //this.props.closeDrawer();
    });
  };

  onSupport = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'support';
    this.props.handleSetContent(null,page).then( () => {
      //this.props.closeDrawer();
    });
  };

  render() {
    const {service,code,showNotification,setPage,setHome,classes = {}, theme} = this.props;
    //const vertical = 'top', horizontal = 'center';
    const logosrc = '/api/logo/icon.png';

    return (
      <Box sx={{...s.container}}>
        <Paper elevation={3} square={false} sx={{...s.paper}}>
          <AppBar position="static" color="primary">
            <Toolbar>
              <Box sx={{...s.logo}} style={{backgroundImage: `url(${logosrc})`}}/>
              <Typography variant="h4" sx={{...s.titlebar}}>
                About NTRMS
              </Typography>
            </Toolbar>
          </AppBar>
          <Box component='form' id="aboutform" sx={{...s.loginform}}>
            <Box sx={{...s.versionBox}}>
              <Typography variant="h5" sx={{...s.versionText}}>
                NTRMS 1.0
              </Typography>
            </Box>
            <Box sx={{...s.versionBox}}>
              <Typography sx={{...s.systemName}}>
                NTR Monitoring System
              </Typography>  
            </Box>
            <Box sx={{...s.featuresBox}}>
              <Typography sx={{...s.featuresText}}>
                Regulatory, Audit, Analytics, Monitoring, Reporting, Integration
              </Typography> 
            </Box>
            <Box sx={{...s.copyrightBox}}>
              <Typography sx={{...s.copyrightText}}>
                &copy; Quest Systems. Powered by Iridis Labs
              </Typography> 
            </Box>
            <Box sx={{...s.emailBox}}>
              <Typography sx={{...s.emailText}}>
                support@quest-sys.com
              </Typography>
            </Box>
            <Box sx={{...s.buttonContainer}}>
              <Button 
                variant="contained" 
                color="primary" 
                sx={{...s.button}} 
                onClick={this.onSupport}
                startIcon={<PersonAdd />}
              >
                Contact us
              </Button>
              <Button 
                variant="outlined" 
                color="primary" 
                sx={{...s.button}} 
                onClick={this.onHelp}
                startIcon={<Help />}
              >
                More info?
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    );
  }

  
}

export default About;
